import React, { memo } from 'react'
import FullWidthCarouselWithAnalytics from 'components/WithAnalytics/Carousel/FullWidthCarouselWithAnalytics'
import { LFSEOfferType } from 'home/components/LookingForSomethingElse/constants'
import HeroOfferLoadingTile from './common/HeroOfferLoadingTile'
import { mediaQueryUp } from 'components/utils/breakpoint'
import styled from 'styled-components'
import { rem } from 'polished'
import HeroOfferCarouselLookingForSomethingElse from '../LookingForSomethingElse/HeroOfferCarouselLookingForSomethingElse'
import HeroOfferCarouselItem from './HeroOfferCarouselItem'

const CarouselItem = styled.div`
  width: 75vw;

  ${mediaQueryUp.tablet} {
    width: 55vw;
  }

  ${mediaQueryUp.desktop} {
    width: 90vw;
    max-width: ${rem(1140)};
  }
`

const LFSEContainer = styled.div`
  width: ${rem(388)};
`

interface Props {
  offerIds: Array<string>;
  tileStyle?: 'search' | 'hero' | 'frontpage';
  hasLFSETile?: boolean;
  offerType?: LFSEOfferType;
  link?: string;
}

function HeroOfferCarousel(props: Props) {
  const { offerIds, tileStyle, hasLFSETile, offerType, link } = props

  return (
    <FullWidthCarouselWithAnalytics snap="start">
      {offerIds.length === 0 && (
        <>
          <CarouselItem as={HeroOfferLoadingTile} />
          <CarouselItem as={HeroOfferLoadingTile} />
        </>
      )}
      {offerIds.map((offerId, i) => <CarouselItem as={HeroOfferCarouselItem}
        key={offerId}
        offerId={offerId}
        position={i}
        tileStyle={tileStyle}
      />)}
      {hasLFSETile && <LFSEContainer>
        <HeroOfferCarouselLookingForSomethingElse
          offerType={offerType}
          link={link}
        />
      </LFSEContainer>}
    </FullWidthCarouselWithAnalytics>
  )
}

export default memo(HeroOfferCarousel)
